<div class="modal-header">
  <h4 class="modal-title">Chat Configuration</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="closeAndRefresh()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-5">Chatroom</div>
    <div
      class="col-3 text-center titlestyle"
      role="button"
      (click)="uncheckFavourites()"
    >
      Favourite
    </div>
    <div
      class="col-3 text-center titlestyle"
      role="button"
      (click)="uncheckAllChat()"
    >
      All Chat
    </div>
  </div>
  <div class="row" *ngFor="let room of this.rooms$ | async">
    <div class="col-5">{{ room.group }}</div>
    <div class="col-3 text-center">
      <div class="form-check" style="margin-top: 1px">
        <input
          class="form-check-input"
          type="checkbox"
          id="favourite"
          [checked]="room.favourite === true"
          (click)="toggleFavourite(room.group, $event)"
        />
      </div>
    </div>
    <div class="col-3 text-center">
      <div class="form-check" style="margin-top: 1px">
        <input
          class="form-check-input"
          type="checkbox"
          id="allchat"
          [checked]="room.allchat === true"
          (click)="toggleAllchat(room.group)"
        />
      </div>
    </div>
  </div>
</div>
